$(document).ready(function() {
    function clamp(q, min, inc, max = Infinity) {
        // Snap to nearest multiple of increment
        q = Math.round(q / inc) * inc;
        // Enforce minimum and maximum
        q = Math.max(min, Math.min(max, q));
        return q;
    }

    function validateQuantity(input, value) {
        const productItem = input.closest('.product-item');
        if (!productItem) return value;
        
        const min = parseInt(productItem.dataset.min) || 1;
        const inc = parseInt(productItem.dataset.inc) || 1;
        const max = productItem.dataset.max ? parseInt(productItem.dataset.max) : Infinity;
        
        return clamp(value, min, inc, max);
    }

    function setupModalQuantitySelector(modalId, product) {
    var $modQtyWrap = $('#' + modalId).find('.mod-qty-wrap');
    $modQtyWrap.empty(); // Clear previous content if any

    var existingQuantity = $(`div[data-variant-id='${product.id}'] .quantity-selector .bb-input`).val() || 0;
    var productItem = $(`div[data-variant-id='${product.id}']`)[0];
    var min = productItem ? (parseInt(productItem.dataset.min) || 1) : 1;
    var inc = productItem ? (parseInt(productItem.dataset.inc) || 1) : 1;
    var max = productItem && productItem.dataset.max ? parseInt(productItem.dataset.max) : '';

    var quantityInputHtml = `
        <div class="modal-quantity-selector">
            <button class="modal-decrease-quantity">-</button>
            <input type="number" class="modal-quantity-input" name="modal-quantity-${product.id}" value="${existingQuantity}" min="${min}" step="${inc}"${max ? ` max="${max}"` : ''} data-product-id="${product.id}">
            <button class="modal-increase-quantity">+</button>
        </div>
    `;

    $modQtyWrap.html(quantityInputHtml);

    // Remove any previously attached event handlers to prevent duplication
    $modQtyWrap.off('click', '.modal-decrease-quantity, .modal-increase-quantity');

    $modQtyWrap.on('click', '.modal-decrease-quantity, .modal-increase-quantity', function() {
        var $input = $(this).siblings('.modal-quantity-input');
        var currentValue = parseInt($input.val()) || 0;
        var isIncrease = $(this).hasClass('modal-increase-quantity');
        var inc = parseInt($input.attr('step')) || 1;
        
        // Use increment value for the change
        var newValue = currentValue + (isIncrease ? inc : -inc);
        
        // Apply quantity rules
        newValue = validateQuantity($input[0], newValue);
        
        $input.val(newValue);
        synchronizeQuantities(product.id, newValue);
        updateFooterBar();
    });
}

    function synchronizeQuantities(productId, newQuantity) {
    $(`div[data-variant-id='${productId}'] .quantity-selector .bb-input`).val(newQuantity);
    $(`.modal-quantity-input[data-product-id='${productId}']`).val(newQuantity);

    // Trigger a custom event to notify the bb_summary.js script
    $(document).trigger('updateQuantities');
    updateFooterBar();
}

    function updateFooterBar() {
        var totalQuantity = 0;
        var totalValue = 0;

        $('.bb-input').each(function() {
            var quantity = parseInt($(this).val());
            var price = parseFloat($(this).closest('.product-item').data('price'));
            totalQuantity += quantity;
            totalValue += quantity * price;
        });

        $('#total-quantity').text(totalQuantity);
        $('#total-value').text(currencySymbol + totalValue.toFixed(2));
    }

    $('.button').click(function() {
        var modalId = $(this).data('target');
        var productId = $(this).closest('.product-item').data('variant-id');
        setupModalQuantitySelector(modalId, {id: productId});
        $('#' + modalId).fadeIn();
    });

    $('.mod-close').click(function() {
        var modalId = $(this).data('close');
        $('#' + modalId).fadeOut();
    });

    $(window).click(function(event) {
        if ($(event.target).hasClass('modal')) {
            $(event.target).fadeOut();
        }
    });

    $('.quantity-selector .bb-input').on('input', function() {
        var productId = $(this).closest('.product-item').data('variant-id');
        var newQuantity = parseInt($(this).val()) || 0;
        
        // Apply quantity rules to manual input
        newQuantity = validateQuantity(this, newQuantity);
        $(this).val(newQuantity);
        
        synchronizeQuantities(productId, newQuantity);
    });

    updateFooterBar(); // Initial update on page load
});
